import ControllerBase from '../../../../global/js/ControllerBase';
import { FHWSearchOutlet } from './o-fhw-search.app';

type ComponentRefs = {
	app: 'fhw-search-app';
};
export default class ControllerFHWSearch extends ControllerBase<ComponentRefs> {
	private static readonly componentRefs: ComponentRefs = {
		app: 'fhw-search-app',
	};

	constructor(element: HTMLElement) {
		super(element, [], Object.values(ControllerFHWSearch.componentRefs));
		this.initApp();
	}

	/**
	 * Render the components to the DOM
	 * @returns void
	 */
	private initApp(): void {
		const domOutlet = this.domUtils.getRef<HTMLElement>(ControllerFHWSearch.componentRefs.app);
		if (domOutlet) {
			FHWSearchOutlet(domOutlet);
		}
	}
}
